import React, { useState, useEffect } from 'react'
import DocumentMeta from 'react-document-meta';
import { useLocation } from 'react-router-dom'


function Meta() {
    const [meta, setMeta] = useState({});
    const location = useLocation();
    const { pathname } = location;
    const CurrentLocation = pathname.split("/").filter(Boolean);
    const path = CurrentLocation[0] || "home";
    const childPath = CurrentLocation[1];
    const metaData = [
  {
    url: 'home',
    metaInfo: {
      title: 'AI Development Company in India | Vidhan Infotech',
      description: 'Vidhan Infotech builds AI-powered applications, chatbots, and automation systems to help businesses grow faster, reduce costs, and scale intelligently.',
      canonical: 'https://www.vidhaninfotech.com/',
      meta: {
        name: {
          keywords: 'AI development company, AI solutions India, chatbot development, automation services, machine learning company Ahmedabad, AI software development'
        }
      }
    }
  },
  {
    url: 'about',
    metaInfo: {
      title: 'About Vidhan Infotech | AI & Automation Experts',
      description: 'Vidhan Infotech is an AI-driven technology company delivering automation, machine learning, and intelligent software solutions for modern businesses.',
      canonical: 'https://www.vidhaninfotech.com/about',
      meta: {
        name: {
          keywords: 'AI company India, automation experts, machine learning company, AI development Ahmedabad, digital transformation company'
        }
      }
    }
  },
  {
    url: 'services',
    metaInfo: {
      title: 'AI Services & Automation Solutions | Vidhan Infotech',
      description: 'Explore AI services including chatbot development, automation tools, machine learning, and custom software development for business growth.',
      canonical: 'https://www.vidhaninfotech.com/services',
      meta: {
        name: {
          keywords: 'AI services, chatbot development, automation solutions, machine learning services, AI software development India'
        }
      }
    }
  },
  {
    url: 'uiux-designs',
    metaInfo: {
      title: 'AI-Driven UI/UX Design Services | Vidhan Infotech',
      description: 'We create modern UI/UX designs powered by data insights and AI to improve user engagement and conversion rates.',
      canonical: 'https://www.vidhaninfotech.com/services/uiux-designs',
      meta: {
        name: {
          keywords: 'AI UI UX design, intelligent UX, modern UI design, user experience design services, UX optimization'
        }
      }
    }
  },
  {
    url: 'application-development',
    metaInfo: {
      title: 'AI Application Development Company | Vidhan Infotech',
      description: 'Build intelligent apps with AI-powered features, automation, and scalable architecture for web and mobile platforms.',
      canonical: 'https://www.vidhaninfotech.com/services/application-development',
      meta: {
        name: {
          keywords: 'AI app development, mobile app AI, intelligent apps, custom software AI, application development company India'
        }
      }
    }
  },
  {
    url: 'portfolio',
    metaInfo: {
      title: 'AI Projects Portfolio | Vidhan Infotech',
      description: 'Explore our portfolio of AI-powered applications, chatbots, automation tools, and innovative digital solutions.',
      canonical: 'https://www.vidhaninfotech.com/portfolio',
      meta: {
        name: {
          keywords: 'AI portfolio, chatbot projects, automation systems, AI case studies, software development portfolio'
        }
      }
    }
  },
  {
    url: 'blog',
    metaInfo: {
      title: 'AI Blogs & Tech Insights | Vidhan Infotech',
      description: 'Stay updated with AI trends, automation strategies, machine learning insights, and digital transformation guides.',
      canonical: 'https://www.vidhaninfotech.com/blog',
      meta: {
        name: {
          keywords: 'AI blogs, automation trends, machine learning articles, AI insights, tech blogs India'
        }
      }
    }
  },
  {
    url: 'career',
    metaInfo: {
      title: 'Careers in AI & Software Development | Vidhan Infotech',
      description: 'Join our team and work on AI, automation, and cutting-edge software development projects.',
      canonical: 'https://www.vidhaninfotech.com/career',
      meta: {
        name: {
          keywords: 'AI jobs India, software developer jobs, machine learning jobs, IT jobs Ahmedabad, tech careers'
        }
      }
    }
  },

  // BLOGS (AI OPTIMIZED)

  {
    url: 'quality-assurance-in-app-development-think-about-business',
    metaInfo: {
      title: 'AI in App Testing & Quality Assurance | Complete Guide',
      description: 'Learn how AI improves quality assurance in app development with automation, faster testing, and better performance.',
      canonical: 'https://www.vidhaninfotech.com/blog/quality-assurance-in-app-development-think-about-business',
      meta: {
        name: {
          keywords: 'AI in testing, app QA automation, software testing AI, quality assurance AI, app testing tools'
        }
      }
    }
  },
  {
    url: 'how-to-pick-the-best-web-app-technology-in-2022',
    metaInfo: {
      title: 'Best AI Tech Stack for Web Apps in 2026',
      description: 'Discover the best AI-powered technologies and frameworks for building scalable and modern web applications.',
      canonical: 'https://www.vidhaninfotech.com/blog/how-to-pick-the-best-web-app-technology-in-2022',
      meta: {
        name: {
          keywords: 'AI tech stack, web app development AI, best frameworks 2026, AI web technologies'
        }
      }
    }
  },
  {
    url: 'the-ultimate-top-5-e-commerce-marketing-strategy-for-best-success',
    metaInfo: {
      title: 'AI E-commerce Marketing Strategies for Growth',
      description: 'Boost your eCommerce sales using AI-driven marketing strategies including automation, personalization, and analytics.',
      canonical: 'https://www.vidhaninfotech.com/blog/the-ultimate-top-5-e-commerce-marketing-strategy-for-best-success',
      meta: {
        name: {
          keywords: 'AI ecommerce marketing, automation marketing, AI personalization, ecommerce growth strategies'
        }
      }
    }
  },
  {
    url: 'step-by-step-guide-know-how-to-design-a-website-in-2022',
    metaInfo: {
      title: 'How to Design an AI-Powered Website (Step-by-Step)',
      description: 'Learn how to design modern websites using AI tools, automation, and smart UI/UX strategies.',
      canonical: 'https://www.vidhaninfotech.com/blog/step-by-step-guide-know-how-to-design-a-website-in-2022',
      meta: {
        name: {
          keywords: 'AI web design, smart UI UX, AI website builder, modern website design, automation design tools'
        }
      }
    }
  },
  {
    url: 'the-best-key-features-of-top-erp-systems-for-business',
    metaInfo: {
      title: 'AI-Powered ERP Systems for Business Growth',
      description: 'Explore how AI enhances ERP systems with automation, predictive analytics, and smart decision-making.',
      canonical: 'https://www.vidhaninfotech.com/blog/the-best-key-features-of-top-erp-systems-for-business',
      meta: {
        name: {
          keywords: 'AI ERP systems, smart ERP, business automation software, enterprise AI solutions'
        }
      }
    }
  },
  {
    url: 'the-7-best-free-website-builders-in-2022',
    metaInfo: {
      title: 'Best AI Website Builders for 2026',
      description: 'Compare top AI-powered website builders that help you create modern, scalable websites faster.',
      canonical: 'https://www.vidhaninfotech.com/blog/the-7-best-free-website-builders-in-2022',
      meta: {
        name: {
          keywords: 'AI website builder, no code AI tools, website automation tools, best builders 2026'
        }
      }
    }
  },
  {
    url: 'how-to-start-an-ecommerce-business-the-best-guide-for-2022-look',
    metaInfo: {
      title: 'How to Start an AI-Powered E-commerce Business',
      description: 'Launch your eCommerce business using AI tools for automation, marketing, and customer engagement.',
      canonical: 'https://www.vidhaninfotech.com/blog/how-to-start-an-ecommerce-business-the-best-guide-for-2022-look',
      meta: {
        name: {
          keywords: 'AI ecommerce startup, ecommerce automation, AI business tools, online business AI'
        }
      }
    }
  },
  {
    url: '10-interesting-facts-more-about-software-development-research',
    metaInfo: {
      title: 'AI Trends Transforming Software Development',
      description: 'Discover how AI is changing software development with automation, code generation, and smarter workflows.',
      canonical: 'https://www.vidhaninfotech.com/blog/10-interesting-facts-more-about-software-development-research',
      meta: {
        name: {
          keywords: 'AI software development, coding AI tools, automation programming, future of development'
        }
      }
    }
  },
  {
    url: '5-most-popular-web-app-frameworks-need-in-2022',
    metaInfo: {
      title: 'Top AI-Ready Web Frameworks for Developers',
      description: 'Explore modern frameworks that support AI-powered applications and scalable web development.',
      canonical: 'https://www.vidhaninfotech.com/blog/5-most-popular-web-app-frameworks-need-in-2022',
      meta: {
        name: {
          keywords: 'AI frameworks, web frameworks 2026, scalable web apps, development tools AI'
        }
      }
    }
  },
  {
    url: 'the-erp-implementation-process-useful-in-5-stages-watch',
    metaInfo: {
      title: 'AI ERP Implementation Guide (Step-by-Step)',
      description: 'Learn how to implement ERP systems with AI automation and smart business workflows.',
      canonical: 'https://www.vidhaninfotech.com/blog/the-erp-implementation-process-useful-in-5-stages-watch',
      meta: {
        name: {
          keywords: 'ERP implementation AI, automation ERP, smart ERP systems, enterprise AI guide'
        }
      }
    }
  },
  {
    url: 'the-best-5-reasons-to-choose-reactjs-for-development',
    metaInfo: {
      title: 'Why ReactJS is Perfect for AI Web Applications',
      description: 'Discover why ReactJS is ideal for building modern AI-powered web applications.',
      canonical: 'https://www.vidhaninfotech.com/blog/the-best-5-reasons-to-choose-reactjs-for-development',
      meta: {
        name: {
          keywords: 'ReactJS AI apps, frontend AI development, React web apps, modern frameworks'
        }
      }
    }
  },
  {
    url: 'here-the-ultimate-guide-on-banking-software-development',
    metaInfo: {
      title: 'AI in Banking Software Development Guide',
      description: 'Learn how AI is transforming banking software with automation, fraud detection, and smart analytics.',
      canonical: 'https://www.vidhaninfotech.com/blog/here-the-ultimate-guide-on-banking-software-development',
      meta: {
        name: {
          keywords: 'AI banking software, fintech AI, fraud detection AI, banking automation'
        }
      }
    }
  },
  {
    url: 'ultimate-best-eCommerce-service-providers',
    metaInfo: {
      title: 'Top AI E-commerce Solutions & Platforms',
      description: 'Discover the best AI-powered eCommerce platforms and tools for scaling your online business.',
      canonical: 'https://www.vidhaninfotech.com/blog/ultimate-best-eCommerce-service-providers',
      meta: {
        name: {
          keywords: 'AI ecommerce tools, smart ecommerce platforms, AI shopping solutions, online store automation'
        }
      }
    }
  }
];
    // Helper to find meta info for current route
    const getMetaInfo = () => {
        // Try to match full path (for blog/services subpages)
        if (childPath) {
            // Try to match blog or services subpages
            const blogMatch = metaData.find(
                m => m.url === `${path}/${childPath}`
            );
            if (blogMatch) return blogMatch.metaInfo;

            // Try to match only by childPath (for direct blog post URLs)
            const childMatch = metaData.find(
                m => m.url === childPath
            );
            if (childMatch) return childMatch.metaInfo;
        }
        // Try to match by main path
        const mainMatch = metaData.find(
            m => m.url === path
        );
        if (mainMatch) return mainMatch.metaInfo;

        // Default meta
        return {
            title: 'Vidhan Infotech Pvt. Ltd.',
            description: 'Vidhan Infotech is a leading IT service provider for web, mobile, and software development.',
            canonical: 'https://www.vidhaninfotech.com/',
            meta: {
                name: { keywords: 'vidhan infotech, software development, web development, mobile app development' }
            }
        };
    };

    useEffect(() => {
        setMeta(getMetaInfo());
        // eslint-disable-next-line
    }, [pathname]);

    return (
        <DocumentMeta {...meta} />
    )
}
export default React.memo(Meta)
